import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import { IUseRouterObjectPageSearchQuery } from 'src/hooks/router/useRouterObjectPage'

export const navigateToObjectTool = createTool({
  id: 'navigate-to-object',
  description:
    'Navigate to a specific CRM object page. Use this when user wants to view details of a contact, deal, company, or any other CRM object.',
  inputSchema: z.object({
    objectSchemeIdentifier: z
      .string()
      .describe('Target object scheme (contact, deal, company)'),
    objectUniqId: z.string().describe('Target object UUID'),
    parentSchemeIdentifier: z
      .string()
      .optional()
      .describe('Parent object scheme (if object has parent)'),
    parentUniqId: z
      .string()
      .optional()
      .describe('Parent object UUID (if object has parent)'),
  }),
  outputSchema: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  execute: async (context: any) => {
    const {
      parentSchemeIdentifier,
      parentUniqId,
      objectSchemeIdentifier,
      objectUniqId,
    } = context

    if (parentSchemeIdentifier && parentUniqId) {
      const querySearch: IUseRouterObjectPageSearchQuery = {
        objectPage: {
          selectedChildren:
            objectSchemeIdentifier && objectUniqId
              ? {
                  schemeName: objectSchemeIdentifier,
                  objectUniqId: objectUniqId,
                }
              : undefined,
        },
      }
      store.dispatch(
        appActions.navigate({
          path: `/storage/${parentSchemeIdentifier}/${parentUniqId}`,
          search: querySearch,
        })
      )
    } else {
      store.dispatch(
        appActions.navigate({
          path: `/storage/${objectSchemeIdentifier}/${objectUniqId}`,
        })
      )
    }

    return {
      success: true,
      message: `Navigating to object `,
    }
  },
})
